import type { MultiplicationFact } from "./model.ts";

export interface TableHint {
  readonly title: string;
  readonly steps: readonly string[];
}

export function buildTableHint(fact: MultiplicationFact): TableHint {
  const { left, right, answer } = fact;

  if (left === 1 || right === 1) {
    const other = left === 1 ? right : left;
    return { title: "Eén keer is hetzelfde getal", steps: [`1 × ${other} = ${answer}`] };
  }
  if (left === 10 || right === 10) {
    const other = left === 10 ? right : left;
    return { title: "Tien keer krijgt een nul", steps: [`10 × ${other} = ${answer}`] };
  }
  if (left === 2 || right === 2) {
    const other = left === 2 ? right : left;
    return {
      title: "Gebruik dubbel",
      steps: [`${other} + ${other} = ${answer}`, `Dus 2 × ${other} = ${answer}`],
    };
  }
  if (left === 5 || right === 5) {
    const other = left === 5 ? right : left;
    return {
      title: "Denk aan vijf groepjes",
      steps: [`5 × ${other} = ${answer}`],
    };
  }

  const splitFactor = left > 5 ? left : right > 5 ? right : left;
  const other = splitFactor === left ? right : left;
  if (splitFactor > 5) {
    const rest = splitFactor - 5;
    const fivePart = 5 * other;
    const restPart = rest * other;
    return {
      title: "Splits slim bij vijf",
      steps: [
        `5 × ${other} = ${fivePart}`,
        `${rest} × ${other} = ${restPart}`,
        `${fivePart} + ${restPart} = ${answer}`,
      ],
    };
  }

  const doublePart = 2 * other;
  const rest = splitFactor - 2;
  const restPart = rest * other;
  return {
    title: "Bouw verder vanaf dubbel",
    steps: [
      `2 × ${other} = ${doublePart}`,
      `${rest} × ${other} = ${restPart}`,
      `${doublePart} + ${restPart} = ${answer}`,
    ],
  };
}
